import React from 'react';
import { withRouter } from 'react-router-dom';
import { MetadataContent } from '@jutro/uiconfig';
import { useLocation } from 'react-router-dom';
import metadata from './AdacLinkExpiredPage.metadata.json5';
import messages from './AdacLinkExpiredPage.messages';
import styles from './AdacLinkExpiredPage.module.scss';

function LinkExpiredPage() {
    const location = useLocation();
    
    const overrides = {
        backButton: {
            onClick: () => {
                window.location.href = 'https://www.adac.de/';
            }
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
    };

    return <MetadataContent
        uiProps={metadata.pageContent}
        overrideProps={overrides}
        {...resolvers}
    />;
}

export default withRouter(LinkExpiredPage);
